import { ElementRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { PageToastMessagesService } from 'Angular/features/components/toast-messages/page-toast-messages-service';
import { UrlsService } from 'Angular/services/core/urls.service';
import { UtilsService } from 'Angular/services/core/utils.service';
import { GlossaryService } from 'GlossaryApp/ts/services/glossary.service';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/core/urls.service";
import * as i2 from "GlossaryApp/ts/services/glossary.service";
import * as i3 from "@angular/platform-browser";
import * as i4 from "Angular/features/components/toast-messages/page-toast-messages-service";
import * as i5 from "Angular/services/core/utils.service";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i7 from "../../../../../../../../search/static/search/ts/features/icon-search-autocomplete/icon-search-autocomplete.component";
import * as i8 from "../../../../../../../../../ycharts/static/ts/features/components/toast-messages/page-toast-messages.component";
import * as i9 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
const _forTrack0 = ($index, $item) => $item.internalName;
function GlossaryTermComponent_Conditional_2_Conditional_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 17);
    i0.ɵɵtext(1, " (Draft)");
    i0.ɵɵelementEnd();
} }
function GlossaryTermComponent_Conditional_2_Conditional_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 18);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", ctx_r1.term.definition, i0.ɵɵsanitizeHtml);
} }
function GlossaryTermComponent_Conditional_2_Conditional_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtext(1, "Formula");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "p", 18);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHtml", ctx_r1.term.formula, i0.ɵɵsanitizeHtml);
} }
function GlossaryTermComponent_Conditional_2_Conditional_25_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtext(1, "Excel Code");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 22)(3, "button", 23);
    i0.ɵɵlistener("click", function GlossaryTermComponent_Conditional_2_Conditional_25_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.copyExcelCodeToClipboard()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(4, "svg", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(5, "pre", 24)(6, "code");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("tooltipTitle", "Copy to Clipboard");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-copy");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.term.excelCode);
} }
function GlossaryTermComponent_Conditional_2_Conditional_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtext(1, "Analysis Tutorial");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "div", 25);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHtml", ctx_r1.sanitizedVideoLink, i0.ɵɵsanitizeHtml);
} }
function GlossaryTermComponent_Conditional_2_Conditional_28_For_4_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 28);
    i0.ɵɵlistener("click", function GlossaryTermComponent_Conditional_2_Conditional_28_For_4_Template_a_click_0_listener() { const relatedTerm_r5 = i0.ɵɵrestoreView(_r4).$implicit; const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.navigateToDefinitionPage(relatedTerm_r5.internalName)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const relatedTerm_r5 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(relatedTerm_r5.name);
} }
function GlossaryTermComponent_Conditional_2_Conditional_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20)(1, "strong", 26);
    i0.ɵɵtext(2, "Related Terms");
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(3, GlossaryTermComponent_Conditional_2_Conditional_28_For_4_Template, 2, 1, "a", 27, _forTrack0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(ctx_r1.relatedTerms);
} }
function GlossaryTermComponent_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3)(3, "div", 4)(4, "div", 5)(5, "h1", 6);
    i0.ɵɵtext(6, "Financial Glossary");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 5)(8, "div", 7)(9, "label", 8);
    i0.ɵɵtext(10, "Search");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "ycn-icon-search-autocomplete", 9);
    i0.ɵɵlistener("submitHandler", function GlossaryTermComponent_Conditional_2_Template_ycn_icon_search_autocomplete_submitHandler_11_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.navigateToDefinitionPage($event.search_id)); });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(12, "div", 10)(13, "a", 11);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(14, "svg", 12);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(15, "span", 13);
    i0.ɵɵtext(16, "View All Terms");
    i0.ɵɵelementEnd()()()()()();
    i0.ɵɵelementStart(17, "div", 14)(18, "div", 4)(19, "div", 15)(20, "h1", 16);
    i0.ɵɵtext(21);
    i0.ɵɵconditionalCreate(22, GlossaryTermComponent_Conditional_2_Conditional_22_Template, 2, 0, "span", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(23, GlossaryTermComponent_Conditional_2_Conditional_23_Template, 1, 1, "p", 18);
    i0.ɵɵconditionalCreate(24, GlossaryTermComponent_Conditional_2_Conditional_24_Template, 3, 1);
    i0.ɵɵconditionalCreate(25, GlossaryTermComponent_Conditional_2_Conditional_25_Template, 8, 3);
    i0.ɵɵconditionalCreate(26, GlossaryTermComponent_Conditional_2_Conditional_26_Template, 3, 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "div", 19);
    i0.ɵɵconditionalCreate(28, GlossaryTermComponent_Conditional_2_Conditional_28_Template, 5, 0, "div", 20);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(11);
    i0.ɵɵproperty("appendToBody", false)("placeholder", "Search Term")("searchType", "glossary_term");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("href", ctx_r1.glossaryHomeUrl, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-back");
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate1("", ctx_r1.term.name, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.term.status === "draft" ? 22 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.term.definition ? 23 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.term.formula ? 24 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.term.excelCode ? 25 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.sanitizedVideoLink ? 26 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.relatedTerms.length > 0 ? 28 : -1);
} }
export class GlossaryTermComponent {
    constructor(eltRef, urlsService, glossaryService, sanitizer, toastMessagesService, utilsService) {
        this.eltRef = eltRef;
        this.urlsService = urlsService;
        this.glossaryService = glossaryService;
        this.sanitizer = sanitizer;
        this.toastMessagesService = toastMessagesService;
        this.utilsService = utilsService;
        this.internalName = '';
        this.relatedTerms = [];
        this.sanitizedVideoLink = '';
        this.internalName = eltRef.nativeElement.getAttribute('internalName');
        this.glossaryHomeUrl = this.urlsService.GLOSSARY.GLOSSARY_HOME;
    }
    ngOnInit() {
        this.glossaryService.getGlossaryTermData(this.internalName).subscribe((data) => {
            this.term = data.term;
            this.relatedTerms = data.relatedTerms;
            if (this.term.videoLink) {
                this.sanitizedVideoLink = this.sanitizer.bypassSecurityTrustHtml(this.term.videoLink);
            }
        });
    }
    navigateToDefinitionPage(term) {
        if (term !== undefined) {
            window.location.href = this.urlsService.getUrl(this.urlsService.GLOSSARY.GLOSSARY_TERM, { term });
        }
    }
    copyExcelCodeToClipboard() {
        if (this.term.excelCode) {
            this.utilsService.copyToClipboard(this.term.excelCode, () => this.toastMessagesService.addMessage('Copied to clipboard'));
        }
    }
}
GlossaryTermComponent.ɵfac = function GlossaryTermComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GlossaryTermComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.UrlsService), i0.ɵɵdirectiveInject(i2.GlossaryService), i0.ɵɵdirectiveInject(i3.DomSanitizer), i0.ɵɵdirectiveInject(i4.PageToastMessagesService), i0.ɵɵdirectiveInject(i5.UtilsService)); };
GlossaryTermComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GlossaryTermComponent, selectors: [["ycn-glossary-term"]], standalone: false, decls: 3, vars: 1, consts: [[1, "page-content"], [1, "page", "page-support"], [1, "page-header", "page-header-support", "page-header-tall"], [1, "container"], [1, "row"], [1, "col-auto"], [1, "page-title"], [1, "form-inline"], [1, "form-label", "form-label-thin"], [3, "submitHandler", "appendToBody", "placeholder", "searchType"], [1, "col-12"], [1, "page-header-navigation-inline", 3, "href"], ["ycnIcon", "", 3, "name"], [1, "page-header-navigation-title"], [1, "glossary-article", "page-body", "container"], [1, "col-9"], [1, "glossary-title"], [1, "text-blue"], [3, "innerHtml"], [1, "col-3"], [1, "glossary-sidebar"], [1, "glossary-subtitle"], [1, "width-full", "bg-gray-base-95", "rounded-4"], ["ycnTooltip", "", 1, "btn", "btn-link", "text-blue", "float-right", 3, "click", "tooltipTitle"], [1, "pt-1", "pb-1", "pl-2", "pr-1"], [1, "video-responsive", 3, "innerHtml"], [1, "glossary-sidebar-title"], ["href", "javascript:void(0)", 1, "glossary-sidebar-item"], ["href", "javascript:void(0)", 1, "glossary-sidebar-item", 3, "click"]], template: function GlossaryTermComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "main", 0);
        i0.ɵɵelement(1, "ycn-page-toast-messages");
        i0.ɵɵconditionalCreate(2, GlossaryTermComponent_Conditional_2_Template, 29, 12, "div", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.term ? 2 : -1);
    } }, dependencies: [i6.IconDirective, i7.IconSearchAutocompleteComponent, i8.PageToastMessagesComponent, i9.TooltipDirective], encapsulation: 2 });
